import React from "react";

/**
 * Cosmic galaxy background — Phase 11.5 adds shooting stars; 11.7 adds a
 * second parallax dust layer + cluster glow for deeper depth.
 *
 * All animation is pure CSS (see index.css `.lifted-cosmos`) and respects
 * prefers-reduced-motion.
 */
export default function CosmicBackground() {
  return (
    <div className="lifted-cosmos" aria-hidden="true">
      <div className="galaxy-dust" />
      <div className="galaxy-cluster" />
      <div className="shooting-star s1" />
      <div className="shooting-star s2" />
      <div className="shooting-star s3" />
      <div className="shooting-star s4" />
    </div>
  );
}
